import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import "./scss/style.scss";

import checkView from "vue-check-view";
Vue.use(checkView);

import inViewportDirective from 'vue-in-viewport-directive'
Vue.directive('in-viewport', inViewportDirective)

new Vue({
  checkView,
  render: h => h(App)
}).$mount("#app");
